import { render, staticRenderFns } from "./AtendimentosDiabetes.vue?vue&type=template&id=42066ed0"
import script from "./AtendimentosDiabetes.vue?vue&type=script&lang=js"
export * from "./AtendimentosDiabetes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports